export default __webpack_public_path__ + "static/media/deleteIcon4.3105ace1.svg";